import { createContext, useContext } from 'react';

/**
 * ControlContext provides access to:
 * - form: object with all form field values including status
 * - id: control form ID (if viewing/editing existing form)
 * - isEdit: boolean, true if in edit mode
 * - isPreview: boolean, true if in preview mode (view-only)
 * - readOnly: boolean, true if form cannot be edited (Master List items)
 * - setFormByKey: function to update form state by key
 */
export const ControlContext = createContext(undefined);

export const useControlContext = () => {
  const cxt = useContext(ControlContext);

  if (!cxt) throw new Error('useControlContext must be used with provider');

  return cxt;
};
